import { PolicyPodetailReq, PolicyPodetailResp } from 'app/bff/models/policy/policyPodetail';
import { PolicyTravelPocancelReq } from 'app/bff/models/policy/policyTravelPocancel';

// State type
export interface DetailState {
  data?: PolicyPodetailResp['policyTravel'];
}
// ::: End

// Actions type constant
export const SERVICE_QUERT_POLICY_DETAIL__FETCH_POLICY_DETAIL = 'SERVICE_QUERT_POLICY_DETAIL__FETCH_POLICY_DETAIL';
export const SERVICE_QUERT_POLICY_DETAIL__FETCH_POLICY_DETAIL_DONE = 'SERVICE_QUERT_POLICY_DETAIL__FETCH_POLICY_DETAIL_DONE';
export const SERVICE_QUERT_POLICY_DETAIL__CANCEL_POLICY = 'SERVICE_QUERT_POLICY_DETAIL__CANCEL_POLICY';
export const SERVICE_QUERT_POLICY_PROTECT_DETAIL__FETCH_POLICY_DETAIL = 'SERVICE_QUERT_POLICY_PROTECT_DETAIL__FETCH_POLICY_DETAIL';
// ::: End

// Action creators type
export interface FetchPolicyDetailAction {
  type: typeof SERVICE_QUERT_POLICY_DETAIL__FETCH_POLICY_DETAIL;
  payload: {
    args: PolicyPodetailReq;
    isCancel: boolean;
  };
}

export interface FetchPolicyProtectDetailAction {
  type: typeof SERVICE_QUERT_POLICY_PROTECT_DETAIL__FETCH_POLICY_DETAIL;
  payload: {
    args: PolicyPodetailReq;
    isCancel: boolean;
  };
}

export interface FetchPolicyDetailDoneAction {
  type: typeof SERVICE_QUERT_POLICY_DETAIL__FETCH_POLICY_DETAIL_DONE;
  payload: {
    response: PolicyPodetailResp['policyTravel'];
  };
}

export interface CancelPolicyAction {
  type: typeof SERVICE_QUERT_POLICY_DETAIL__CANCEL_POLICY;
  payload: {
    args: PolicyTravelPocancelReq;
    successMessageTitle: string;
    successMessageContent: string;
  };
}

export type DetailActions =
    FetchPolicyDetailAction
    | FetchPolicyDetailDoneAction
    | FetchPolicyProtectDetailAction
    | CancelPolicyAction;
// ::: End
